import { useUserQuery } from 'graphql/generated'
import { ProfileBaseInfo } from 'components/profiles/ProfileBaseInfo'
import moment from 'moment'
import Spinner from 'components/Spinner'
import { getDateFormat } from 'lib/datetime'
import BaseModal from 'components/modals/BaseModal'

export type IProps = {
  userId: string
  onClose?: Callback
}

export const getMonthDay = date => `${moment(date).format(getDateFormat())}`

export const UserModal = ({ userId, onClose }: IProps) => {
  const { loading, data } = useUserQuery({
    variables: {
      id: userId
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  })

  const user = data?.user

  return (
    <BaseModal onClose={onClose}>
      <div className="p-4 flex flex-col w-full relative">
        {!data?.user && loading && <Spinner />}

        {!!user && (
          <ProfileBaseInfo
            user={user}
            clickable={true}
            showViewProfileButton
            showSocial={false}
          />
        )}
      </div>
    </BaseModal>
  )
}
